interface Props {
  nota: string
  alCambiarNota: (nota: string) => void
  alGuardar: () => void
  guardando: boolean
  deshabilitado: boolean
}

/** Nota + "Guardar versión". La misma en la cotización estándar y en la industrial. */
export function BarraGuardar({ nota, alCambiarNota, alGuardar, guardando, deshabilitado }: Props) {
  return (
    <div className="tarjeta barra-guardar">
      <label>
        Nota de esta versión (opcional)
        <input value={nota} onChange={(e) => alCambiarNota(e.target.value)} maxLength={500} placeholder="Ej.: con descuento de feria" />
      </label>
      <button className="primario" onClick={alGuardar} disabled={deshabilitado}>
        {guardando ? 'Guardando…' : 'Guardar versión'}
      </button>
    </div>
  )
}
